import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-square"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFormSquare;
